import { render, staticRenderFns } from "./TiemposMobile.vue?vue&type=template&id=c37856d0"
import script from "./TiemposMobile.vue?vue&type=script&lang=js"
export * from "./TiemposMobile.vue?vue&type=script&lang=js"
import style0 from "./TiemposMobile.vue?vue&type=style&index=0&id=c37856d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports